import { NavLink, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import home from "../images/home.png";
import homework from "../images/homework.png";
import score from "../images/score.png";
import "../styles/sidebar.css";
import { MdLogout } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import api from "../pages/api";

const Sidebar = () => {
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            const refreshToken = localStorage.getItem("refreshToken");

            if (!refreshToken) {
                localStorage.clear();
                navigate("/login");
                window.location.reload();
                return;
            }

            await api.post("manager/api/v1/logout", { refresh: refreshToken });

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");

            navigate("/login");
            window.location.reload(); // <-- refresh after navigation
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.clear();
            navigate("/login");
            window.location.reload(); // <-- even if error
        }
    };


    return (
        <div className="sidebar-container">
            <div className="p-5">
                <div className="d-flex justify-content-center">
                    <div className=" logo-container1">
                        <span >ythonteek</span>
                        <img className="mb-3" src={logo} alt="Logo" width={42} height={42} />
                    </div>
                </div>
                <div className="mt-4" style={{ border: "1px solid rgba(0, 0, 0, 0.25)" }}></div>
                <div className="py-5 px-3 ps-0">
                    <div style={{ position: "relative" }}>
                        <NavLink to="/" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={home} width={30} height={30} alt="Home" />
                            <span className="mx-2">خونه</span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/about" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <FaUser style={{ fontSize: "30px" }} className="clr" />
                            <span className="mx-2">درباره من</span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/homework" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={homework} width={30} height={30} alt="Homework" />
                            <span className="mx-2"> تکالیف و جزوه ها</span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/score" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <img src={score} width={30} height={30} alt="Scores" />
                            <span className="mx-2"> مدارک و کارنامه ها</span>
                        </NavLink>
                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink to="/roadmap" className={({ isActive }) => `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRulee="evenodd" d="M15 2.5C20.8925 2.5 23.8387 2.5 25.6688 4.33C26.2987 4.96 26.7125 5.7225 26.9837 6.69125L6.69125 26.9837C5.7225 26.7125 4.96 26.2987 4.33 25.6688C2.5 23.84 2.5 20.8925 2.5 15C2.5 9.1075 2.5 6.16125 4.33 4.33C6.1625 2.5 9.1075 2.5 15 2.5ZM6.875 10.9462C6.875 13.1775 8.27125 15.7812 10.45 16.7125C10.9575 16.9288 11.5425 16.9288 12.05 16.7125C14.2288 15.7812 15.625 13.1775 15.625 10.9462C15.625 8.6975 13.6663 6.875 11.25 6.875C8.83375 6.875 6.875 8.6975 6.875 10.9462Z" fill="rgba(43, 167, 105, 1)" />
                                <path d="M13.125 11.25C13.125 11.7473 12.9275 12.2242 12.5758 12.5758C12.2242 12.9275 11.7473 13.125 11.25 13.125C10.7527 13.125 10.2758 12.9275 9.92417 12.5758C9.57254 12.2242 9.375 11.7473 9.375 11.25C9.375 10.7527 9.57254 10.2758 9.92417 9.92417C10.2758 9.57254 10.7527 9.375 11.25 9.375C11.7473 9.375 12.2242 9.57254 12.5758 9.92417C12.9275 10.2758 13.125 10.7527 13.125 11.25Z" fill="rgba(43, 167, 105, 1)" />
                                <path opacity="0.5" d="M27.3626 8.96497C27.5001 10.5412 27.5001 12.5075 27.5001 15C27.5001 20.1675 27.5001 23.0687 26.2664 24.9387L18.8251 17.5L27.3626 8.96497ZM24.9401 26.265L17.5014 18.8262L8.96387 27.3612C10.5414 27.5 12.5076 27.5 15.0014 27.5C20.1689 27.5 23.0701 27.5 24.9401 26.265Z" fill="rgba(43, 167, 105, 1)" />
                            </svg>

                            <span className="mx-2"> نقشه راه</span>
                        </NavLink>
                    </div>
                    {/* دکمه لاگ اوت */}
                    <div style={{ position: "relative", cursor: "pointer" }} onClick={handleLogout}>
                        <div className="sidebar-itemm my-5 d-block">
                            <MdLogout style={{ fontSize: "30px" }} />
                            <span className="mx-2">بیرون رفتن</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
